import { render, staticRenderFns } from "./Japanese.vue?vue&type=template&id=f4fbdf04&scoped=true"
import script from "./Japanese.vue?vue&type=script&lang=js"
export * from "./Japanese.vue?vue&type=script&lang=js"
import style0 from "./Japanese.vue?vue&type=style&index=0&id=f4fbdf04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fbdf04",
  null
  
)

export default component.exports